import './FDOTHeader.css';
import { Stack } from '@mui/material';
import { IconButton } from '@mui/material';
import { forwardRef } from 'react';

//Show one icon
const Icon = forwardRef(({ icon, onClick, label }, ref) => {
  return (
    <IconButton aria-label={label} size="large" onClick={onClick} ref={ref}>
      {icon.name}
    </IconButton>
  );
});

//Show stack of icons
function IconStack(props) {
  const icons = props.iconList;
  const columns = [];
  for (let i = 0; i < icons.length; i++) {
    columns.push(
      <Icon
        icon={icons[i]}
        key={icons[i].label}
        onClick={() => {
          icons[i]?.onclick();
        }}
        ref={icons[i]?.ref}
      />
    );
  }

  return (
    <div className="icons">
      <Stack direction="row" spacing={2}>
        {columns}
      </Stack>
    </div>
  );
}

//Generate Header
const FDOTHeader = forwardRef(({ Title, Department, IconList }, ref) => {
  return (
    <header ref={ref}>
      <img
        src="https://webincludes.dot.state.fl.us/images/FDOTLogolg.png"
        className="App-logo"
        alt="FDOT logo"
      />
      <h1 className="title">{Title}</h1>
      <div className="header-right">
        <h3 className="department">{Department}</h3>
        <IconStack iconList={IconList} />
      </div>
    </header>
  );
});

export default FDOTHeader;
